// @ts-nocheck
import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

import { Box, Button, Link, Container, Typography, TextField, GridLegacy as Grid, useMediaQuery, Modal } from '@mui/material';


export default function StepperBottomRow({ handleCancel, handleSubmit, loading}){
    return (
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', pt: 3 }}>
                <Button
                    color="inherit"
                    variant="outlined"
                    size="large"
                    onClick={handleCancel}
                    sx={{ mr: 1 }}
                >
                    Cancel
                </Button>
                <Box />
                <LoadingButton
                    onClick={handleSubmit}
                    loading={loading}
                    variant="outlined"
                    size="large"
                >
                   Update
                </LoadingButton>
            </Box>
    )                     
                        
  }
  